import React from "react";

const HeaderLogo = () => (
  <img src="/images/footik-mark.svg" alt="Footik" width="40" height="40" />
);

export default HeaderLogo;
